module.exports = __webpack_public_path__ + "static/media/figureman-1.3ed69e99.png";